/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Type_TendonInputs */

const en_us2_bodymap_type_tendon = /** @type {(inputs: Bodymap_Type_TendonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tendon`)
};

const pt_br2_bodymap_type_tendon = /** @type {(inputs: Bodymap_Type_TendonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tendão`)
};

const es_419_bodymap_type_tendon = /** @type {(inputs: Bodymap_Type_TendonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tendón`)
};

const pt_pt2_bodymap_type_tendon = /** @type {(inputs: Bodymap_Type_TendonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tendão`)
};

const fr_fr2_bodymap_type_tendon = /** @type {(inputs: Bodymap_Type_TendonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tendon`)
};

const de_de2_bodymap_type_tendon = /** @type {(inputs: Bodymap_Type_TendonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehne`)
};

const it_it2_bodymap_type_tendon = /** @type {(inputs: Bodymap_Type_TendonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tendine`)
};

/**
* | output |
* | --- |
* | "Tendon" |
*
* @param {Bodymap_Type_TendonInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_type_tendon = /** @type {((inputs?: Bodymap_Type_TendonInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Type_TendonInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_type_tendon(inputs)
	if (locale === "es-419") return es_419_bodymap_type_tendon(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_type_tendon(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_type_tendon(inputs)
	if (locale === "de-DE") return de_de2_bodymap_type_tendon(inputs)
	if (locale === "it-IT") return it_it2_bodymap_type_tendon(inputs)
	return en_us2_bodymap_type_tendon(inputs)
});
export { bodymap_type_tendon as "bodymap.type.tendon" }